import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rn-vui/themed';
import {observer} from 'mobx-react-lite';

import Text from '../../../components/themed/Text';
import {useStores} from '../../../stores/use-stores';

/**
 * DIS-1608: MFL's reason for refusing the attached coupon.
 *
 * Only the refusal renders. A coupon that qualifies needs no panel — the code
 * sits in the row above with its status glyph, and the cart total below already
 * carries a `Coupon <code>` line with the amount. Restating either here was
 * saying the same thing three times.
 *
 * The refusal sentence is MFL's, verbatim: the client models no minimum,
 * shortfall or cap of its own, and MFL exposes none of them as numbers.
 */
const CouponStatusPanel = observer(() => {
  const {cartStore} = useStores();
  const styles = useStyles();

  if (!cartStore.currentOrder?.coupon_code) return null;
  if (cartStore.couponStatus !== 'unqualified') return null;

  const detail = cartStore.couponIssue?.detail;
  if (!detail) return null;

  return (
    <View testID="coupon-status-panel" accessibilityLiveRegion="polite" style={styles.panel}>
      <Text testID="coupon-status-panel-detail" style={styles.detail}>
        {detail}
      </Text>
    </View>
  );
});

const useStyles = makeStyles(theme => ({
  panel: {
    backgroundColor: theme.colors.warning,
    padding: 12,
    borderRadius: 4,
    // Symmetric: the panel sits between the coupon row and the cart-total card,
    // and without the bottom margin it rendered flush against the card on mobile.
    marginTop: 8,
    marginBottom: 8,
  },
  detail: {color: theme.colors.black, fontSize: 13, lineHeight: 18},
}));

export default CouponStatusPanel;
